import React from "react";

const HomeIcon = (props: any) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>home-icon</title>
      <path
        d="M12.005 13.997c0-.008-8 0-8 0 .007 0 0-5 0-5 0-.552-.448-1-1-1s-1 .448-1 1v5c0 1.105.895 2 2 2h8c1.102-.003 1.994-.897 1.994-2v-5c0-.552-.45-1-1-1-.553 0-1 .448-1 1l.005 5zm2.372-6.23c.202.173.467.255.73.228.266-.028.508-.163.67-.374.348-.445.287-1.085-.14-1.457L8.692.263c-.41-.35-1.012-.35-1.42 0L.365 6.135c-.427.372-.49 1.012-.14 1.458.16.21.403.346.668.373.264.028.528-.054.73-.227l6.37-5.39 6.376 5.422.007-.005zm-6.354 3.22c1.1-.003 1.99-.897 1.988-1.998 0-1.1-.895-1.992-1.995-1.99-1.1 0-1.992.893-1.992 1.993.003 1.103.898 1.994 2 1.994z"
        fill="#000"
        fillRule="evenodd"
      />
    </svg>
  );
};

export default HomeIcon;
